// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrashOutlinedSvg from "@fishx/icons-svg/es/asn/TrashOutlined";
import FishxIcon from '../components/FishxIcon';

var TrashOutlined = function TrashOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrashOutlinedSvg
  }));
};

TrashOutlined.displayName = 'TrashOutlined';
export default React.forwardRef(TrashOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TrashOutlined.js
// module id = 4290
// module chunks = 0